import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_7zkdvevji4: FaireBrandEntity = {
  token: "b_7zkdvevji4",
  type: "brand",
  name: "Ariella USA",
  avatarUrl:
    "https://cdn.faire.com/fastly/0d4beba3386d76bbfcf9a7629aeee5518f2d0a83ee05e40e53167642ee9ccbdf.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/5ee1ccb6c22f5d5d4be0ea3a568f4032a6f731bd3bbdbf17e4cab3f1002a1b2a.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/0d4beba3386d76bbfcf9a7629aeee5518f2d0a83ee05e40e53167642ee9ccbdf.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/5ee1ccb6c22f5d5d4be0ea3a568f4032a6f731bd3bbdbf17e4cab3f1002a1b2a.jpeg",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 4,
  isInsider: true,
  description:
    "An established name in the wholesale fashion industry, Ariella USA is a family owned and operated brand created in 1993. We grew our roots in Mid-town Manhattan and moved our wholesale manufacturing operation to Downtown Los Angeles in 2010. Inspired by finding the best quality fabrics and newest prints, we pride ourselves on the fact that all our products are made in LA with top craftsmanship. We're constantly striving to grow and evolve so that we can always create innovative, contemporary styles for our clients.",
  meta: {
    source: "api",
    importedAt: "2026-07-23T06:21:42.582Z",
    importedBy: "entity-db-cli",
  },
};
